import React, { useState, useEffect } from 'react';

function Link({ url }) {
  const [metadata, setMetadata] = useState(null);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  // Extract domain for favicon
  const getDomain = (url) => {
    try {
      const domain = new URL(url).hostname;
      return domain;
    } catch (e) {
      return '';
    }
  };

  const domain = getDomain(url);
  const faviconUrl = domain ? `https://www.google.com/s2/favicons?domain=${domain}&sz=32` : '';

  // Get the best available title from metadata
  const getTitleFromMetadata = (metadata) => {
    if (!metadata) return null;
    
    // Try different sources for the title in order of preference
    return metadata.title || 
           metadata.openGraph?.title || 
           metadata.twitterCard?.title || 
           null;
  };

  // Truncate text to 35 characters
  const truncateText = (text) => {
    if (!text) return '';
    // Remove any extra whitespace and newlines
    const cleanText = text.trim().replace(/\s+/g, ' ');
    return cleanText.length > 30 ? cleanText.substring(0, 30) + '...' : cleanText;
  };

  useEffect(() => {
    const fetchMetadata = async () => {
      try {
        setIsLoading(true);
        setError(null);
        
        // Add timeout to the fetch request
        const controller = new AbortController();
        const timeoutId = setTimeout(() => controller.abort(), 5000); // 5 second timeout

        const response = await fetch('/api/linkPreview', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ url }),
          signal: controller.signal
        });

        clearTimeout(timeoutId);

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        if (data.metadata) {
          setMetadata(data.metadata);
        }
      } catch (err) {
        console.error('Error fetching link metadata:', err);
        setError(err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchMetadata();
  }, [url]);

  // Get the best available title and truncate it
  const displayText = truncateText(error || isLoading ? url : (getTitleFromMetadata(metadata) || url));

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      data-url={url}
      className="text-blue-600 hover:text-blue-800 hover:underline inline-flex items-start gap-1.5 align-text-top"
      title={url}
    >
      {faviconUrl && (
        <img 
          src={faviconUrl} 
          alt="" 
          className="w-4 h-4 mt-1 inline-block"
          onError={(e) => {
            e.target.style.display = 'none';
          }}
        />
      )}
      <span className="inline-block">{displayText}</span>
    </a>
  );
}

export default Link; 